import type { QuizScreenModel } from './QuizScreenModelScreen';

export class QuizScreenController {
  constructor(private readonly model: QuizScreenModel) {}

  handleAnswer = (index: number) => {
    this.model.onAnswer?.(index);
  };

  handleGoBack = () => {
    this.model.onGoBack?.();
  };

  handleClueClick = () => {
    this.model.onClueClick?.();
  };

  handleDailyLimitZero = () => {
    this.model.onDailyLimitZero?.();
  };
}
